import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.Checklist.title',
    defaultMessage: 'Checklist',
  },
  houseType: {
    id: 'app.containers.Checklist.houseType',
    defaultMessage: 'Tipo de imóvel',
  },
  finishSessionTitle: {
    id: 'app.containers.Checklist.finishSessionTitle',
    defaultMessage: 'Quer mesmo concluir?',
  },
  finishSessionDescription: {
    id: 'app.containers.Checklist.finishSessionDescription',
    defaultMessage: 'Concluindo a sessão, se necessário, você poderá revisar o checklist na aba de “Pendentes”.',
  },
  finish: {
    id: 'app.containers.Checklist.finish',
    defaultMessage: 'Concluir',
  },
  review: {
    id: 'app.containers.Checklist.review',
    defaultMessage: 'Revisar',
  },
  finishedSessionTitle: {
    id: 'app.containers.Checklist.finishedSessionTitle',
    defaultMessage: 'Sessão concluída!',
  },
  finishedSessionDescription: {
    id: 'app.containers.Checklist.finishedSessionDescription',
    defaultMessage: 'O checklist está finalizado e pronto para receber o upload de fotos da sessão.',
  },
  gotIt: {
    id: 'app.containers.Checklist.gotIt',
    defaultMessage: 'OK, Entendi',
  },
  errorMessage: {
    id: 'app.containers.Checklist.errorMessage',
    defaultMessage: 'Não foi possível concluir. Verifique o preenchimento dos campos ou tente mais tarde.',
  },
  errorMessageWithDetails: {
    id: 'app.containers.Checklist.errorMessageWithDetails',
    defaultMessage: 'Não foi possível concluir. {errorDetails}',
  },
  finishChecklist: {
    id: 'app.containers.Checklist.finishChecklist',
    defaultMessage: 'Concluir sessão de fotos',
  },
  invalid: {
    id: 'app.containers.Checklist.House.invalid',
    defaultMessage: 'Preencha todos os itens',
  },
  checklistOnboardingStep1Title: {
    id: 'app.containers.Checklist.onboarding.step1.title',
    defaultMessage: 'Informações mais completas para os nossos clientes',
  },
  checklistOnboardingStep1Description: {
    id: 'app.containers.Checklist.onboarding.Step1.Description',
    defaultMessage: 'Para o anúncio ficar completo, pedimos que você confirme o nome do condominío, se necessário.',
  },
  checklistOnboardingStep2Title: {
    id: 'app.containers.Checklist.onboarding.step2.title',
    defaultMessage: 'Os detalhes sempre fazem a diferença ',
  },
  checklistOnboardingStep2Description: {
    id: 'app.containers.Checklist.onboarding.Step2.Description',
    defaultMessage: 'Sempre tire fotos da fachada, áreas comuns e diferenciais, como: playground, garagem e piscina.',
  },
  checklistOnboardingStep3Title: {
    id: 'app.containers.Checklist.onboarding.step3.title',
    defaultMessage: 'Legendas de acordo com as fotografias',
  },
  checklistOnboardingStep3Description: {
    id: 'app.containers.Checklist.onboarding.Step3.Description',
    defaultMessage: `No upload das fotos, lembre-se de cadastrar legendas corretas no checklist. 
    Se é uma piscina, playground ou academia, por exemplo.`,
  },
  checklistOnboardingDefaultLabel: {
    id: 'app.containers.Checklist.onboarding.defaultLabel',
    defaultMessage: 'fotos',
  },
  checklistOnboardingBtnTextFinish: {
    id: 'app.containers.Checklist.onboarding.BtnTextFinish',
    defaultMessage: 'Iniciar checklist',
  },
});

export const mountFinishSessionError = (error) => ({
  values: {
    errorDetails: error &&
      error.message &&
        error.message.mapaErros &&
          Object.keys(error.message.mapaErros).reduce((acc, curr, i, arr) => `${acc +
                    curr} está ${error.message.mapaErros[curr]
          }${i < arr.length - 1 ? ', ' : ''}`, ''),
  },
});
